export type OpenAiTextModelOptionType =
    | 'davinci-002'
    | 'gpt-4-1106-preview'
    | 'gpt-4-turbo-preview'
    | 'gpt-4-0125-preview'
    | 'babbage-002'
    | 'gpt-4'
    | 'gpt-4-0613'
    | 'gpt-3.5-turbo-16k'
    | 'gpt-3.5-turbo-1106'
    | 'gpt-3.5-turbo-instruct-0914'
    | 'gpt-3.5-turbo-instruct'
    | 'gpt-3.5-turbo-0301'
    | 'gpt-3.5-turbo-0125'
    | 'gpt-3.5-turbo'
    | 'gpt-4-turbo-2024-04-09'
    | 'gpt-4-turbo'
    | 'gpt-3.5-turbo-0613'
    | 'gpt-4o'
    | 'gpt-4o-2024-05-13'

export type AnthropicTextModelOptionType = 'claude-3-5-sonnet-20240620'
// | 'claude-3-opus-20240229'
// | 'claude-3-sonnet-20240229'
// | 'claude-3-haiku-20240307'

export type GroqTextModelOptionType =
    | 'gemma2-9b-it'
    | 'llama-3.1-8b-instant'
    | 'llama-3.1-70b-versatile'
    | 'llama-3.1-405b-reasoning'
    | 'mixtral-8x7b-32768'

export type BedrockTextModelOptionType =
    | 'mistral.mixtral-8x7b-instruct-v0:1'
    | 'mistral.mistral-large-2402-v1:0'
    | 'meta.llama3-1-8b-instruct-v1:0'
    | 'meta.llama3-1-70b-instruct-v1:0'
    | 'meta.llama3-1-405b-instruct-v1:0'

export type ImageModelOptionType = {
    value: 'dall-e-3' | 'dall-e-2'
    label: 'dall-e-3' | 'dall-e-2'
}

export type OptionType = {
    value: 'StreamPrompting' | 'ImageResponse' | 'IsAlive' | 'TextPrompting'
    label: 'Text' | 'Image' | 'IsAlive' | 'TextPrompting'
}

export const responseOptions: OptionType[] = [
    { value: 'StreamPrompting', label: 'Text' },
    { value: 'ImageResponse', label: 'Image' },
    // { value: 'IsAlive', label: 'IsAlive' },
    // { value: 'TextPrompting', label: 'TextPrompting' },
]

export const openAiTextModelsOptions: {
    value: OpenAiTextModelOptionType
    label: OpenAiTextModelOptionType
}[] = [
    // { value: 'gpt-3.5-turbo', label: 'gpt-3.5-turbo' },
    // { value: 'gpt-4-1106-preview', label: 'gpt-4-1106-preview' },
    // { value: 'gpt-4-turbo-preview', label: 'gpt-4-turbo-preview' },
    // { value: 'gpt-4-0125-preview', label: 'gpt-4-0125-preview' },
    // { value: 'gpt-4', label: 'gpt-4' },
    // { value: 'gpt-4-0613', label: 'gpt-4-0613' },
    // { value: 'gpt-3.5-turbo-16k', label: 'gpt-3.5-turbo-16k' },
    // { value: 'gpt-3.5-turbo-1106', label: 'gpt-3.5-turbo-1106' },
    // { value: 'gpt-3.5-turbo-0125', label: 'gpt-3.5-turbo-0125' },
    // { value: 'gpt-4-turbo-2024-04-09', label: 'gpt-4-turbo-2024-04-09' },
    // { value: 'gpt-4-turbo', label: 'gpt-4-turbo' },
    { value: 'gpt-4o', label: 'gpt-4o' },
    // { value: 'gpt-4o-2024-05-13', label: 'gpt-4o-2024-05-13' },
    // { value: 'gpt-3.5-turbo-0125', label: 'gpt-3.5-turbo-0125' },
    // { value: 'gpt-4-turbo-2024-04-09', label: 'gpt-4-turbo-2024-04-09' },
    // { value: 'gpt-4-turbo', label: 'gpt-4-turbo' },
    // { value: 'gpt-3.5-turbo-0613', label: 'gpt-3.5-turbo-0613' },
    // { value: 'gpt-4o', label: 'gpt-4o' },
    // { value: 'gpt-4o-2024-05-13', label: 'gpt-4o-2024-05-13' },
]

export const anthropicTextModelsOptions: {
    value: AnthropicTextModelOptionType
    label: AnthropicTextModelOptionType
}[] = [
    // { value: 'claude-3-opus-20240229', label: 'claude-3-opus-20240229' },
    // { value: 'claude-3-sonnet-20240229', label: 'claude-3-sonnet-20240229' },
    // { value: 'claude-3-haiku-20240307', label: 'claude-3-haiku-20240307' },
    { value: 'claude-3-5-sonnet-20240620', label: 'claude-3-5-sonnet-20240620' },
]

export const groqTextModelsOptions: {
    value: GroqTextModelOptionType
    label: GroqTextModelOptionType
}[] = [
    // { value: 'gemma2-9b-it', label: 'gemma2-9b-it' },
    // { value: 'llama-3.1-8b-instant', label: 'llama-3.1-8b-instant' },
    { value: 'llama-3.1-70b-versatile', label: 'llama-3.1-70b-versatile' },
    // { value: 'llama-3.1-405b-reasoning', label: 'llama-3.1-405b-reasoning' },
    // { value: 'mixtral-8x7b-32768', label: 'mixtral-8x7b-32768' },
]

export const bedrockTextModelsOptions: {
    value: BedrockTextModelOptionType
    label: BedrockTextModelOptionType
}[] = [
    { value: 'mistral.mixtral-8x7b-instruct-v0:1', label: 'mistral.mixtral-8x7b-instruct-v0:1' },
    { value: 'mistral.mistral-large-2402-v1:0', label: 'mistral.mistral-large-2402-v1:0' },
    { value: 'meta.llama3-1-8b-instruct-v1:0', label: 'meta.llama3-1-8b-instruct-v1:0' },
    { value: 'meta.llama3-1-70b-instruct-v1:0', label: 'meta.llama3-1-70b-instruct-v1:0' },
    { value: 'meta.llama3-1-405b-instruct-v1:0', label: 'meta.llama3-1-405b-instruct-v1:0' },
]

export const imageModelsOptions: ImageModelOptionType[] = [
    { value: 'dall-e-3', label: 'dall-e-3' },
    { value: 'dall-e-2', label: 'dall-e-2' },
]

export const openAiRolesOptions = [
    { value: 'user', label: 'user' },
    { value: 'assistant', label: 'assistant' },
    { value: 'system', label: 'system' },
]

export const AnthropicRolesOptions = [
    { value: 'user', label: 'user' },
    { value: 'assistant', label: 'assistant' },
]

export const providersOptions = [
    { value: 'OpenAI', label: 'OpenAI' },
    { value: 'Anthropic', label: 'Anthropic' },
    { value: 'Groq', label: 'Groq' },
    // { value: 'Bedrock', label: 'Bedrock' },
]

// ImageResponse
export const styleOptions = [
    { value: 'vivid', label: 'vivid' },
    { value: 'natural', label: 'natural' },
]

export const qualityOptions = [
    { value: 'standard', label: 'standard' },
    { value: 'hd', label: 'hd' },
]

export const dall_e2SizesOptions = [
    { value: '1024x1024', label: '1024x1024' },
    { value: '512x512', label: '512x512' },
    { value: '256x256', label: '256x256' },
]

export const dall_e3SizesOptions = [
    { value: '1792x1024', label: '1792x1024' },
    { value: '1024x1792', label: '1024x1792' },
    { value: '1024x1024', label: '1024x1024' },
]

export const samplersOptions = [
    { value: 'default', label: 'default' },
    { value: 'ddim', label: 'ddim' },
    { value: 'plms', label: 'plms' },
    { value: 'k_euler', label: 'k_euler' },
    { value: 'k_euler_ancestral', label: 'k_euler_ancestral' },
    { value: 'k_heun', label: 'k_heun' },
    { value: 'k_dpm_2', label: 'k_dpm_2' },
    { value: 'k_dpm_2_ancestral', label: 'k_dpm_2_ancestral' },
    { value: 'k_dpmpp_2s_ancestral', label: 'k_dpmpp_2s_ancestral' },
    { value: 'k_lms', label: 'k_lms' },
    { value: 'k_dpmpp_2m', label: 'k_dpmpp_2m' },
    { value: 'k_dpmpp_sde', label: 'k_dpmpp_sde' },
]

export interface CortexState {
    StreamPrompting: {
        uid: number | string
        provider: string
        model: string
        seed: number | string
        temperature: number | string
        max_tokens: number | string
        top_p: number | string
        top_k: number | string
        timeout: number | string
    }
    ImageResponse: {
        provider: string
        seed: number | string
        samples: number | string
        cfg_scale: number | string
        sampler: string
        steps: number | string
        model: string
        style: string
        size: string
        height: number | string
        width: number | string
        quality: string
    }
    IsAlive: {
        answer: string
    }
}

export const cortexInitialState: CortexState = {
    StreamPrompting: {
        uid: 3,
        provider: 'OpenAI',
        model: 'gpt-3.5-turbo',
        seed: 1234,
        temperature: 0.5,
        max_tokens: 2048,
        top_p: 0.8,
        top_k: 1000,
        timeout: 3,
    },
    ImageResponse: {
        provider: 'OpenAI',
        seed: 1234,
        samples: 1,
        cfg_scale: 8,
        sampler: '',
        steps: 45,
        model: 'dall-e-3',
        style: 'vivid',
        size: '1024x1024',
        height: 1024,
        width: 1024,
        quality: 'hd',
    },
    IsAlive: {
        answer: 'test',
    },
}

export const GPT_LOGO =
    'https://static.vecteezy.com/system/resources/previews/021/059/825/non_2x/chatgpt-logo-chat-gpt-icon-on-green-background-free-vector.jpg'

export const examples = [
    'What are the main causes of climate change?',
    'What were the main events of World War II?',
    'What are the benefits of a balanced diet?',
]

export const imageExamples = [
    'A sunset over the ocean.',
    'A dragon flying over a castle.',
    'Colorful geometric shapes.',
]
